export type WidgetEnum =
    | ButtonEnum
    | LayoutEnum
    | TextEnum
    | InputEnum
    | CheckboxEnum
    | DropdownEnum
    | AnimationIconEnum
    | ListEnum
    | RowEnum
    | CalculatorEnum
    | SeparatorEnum
    | CarouselEnum
    | ActionWidgetEnum
    | StoriesEnum
    | ImageEnum
    | CardEnum
    | KycEnum
    | MpiEnum
    | BarEnum;

export enum LayoutEnum {
    WRAPPER_LAYOUT = 'WrapperLayout',
    VERTICAL_LAYOUT = 'VerticalLayout',
    VERTICAL_LAYOUT_WIDE = 'VerticalLayoutWide',
    HORIZONTAL_LAYOUT = 'HorizontalLayout',
    FLOATING_LAYOUT = 'FloatingLayout',
    SEPARATE_CONTENT_LAYOUT = 'SeparateContentLayout',
    CALCULATOR_CONTENT_LAYOUT = 'CalculatorContentLayout',
    WEB_VIEW_LAYOUT = 'WebViewLayout',
}

export enum AnimationIconEnum {
    Success = 'Success',
    Error = 'Error',
    Loading = 'Loading',
}

export enum BarEnum {
    LIMIT_BAR = 'LimitBar',
    REFERRALS_PROGRESS = 'ReferralsProgress',
}

export enum ButtonEnum {
    BUTTON_PILL = 'ButtonPill',
    BUTTON_CIRCLE = 'ButtonCircle',
    BUTTON_ROW = 'ButtonRow',
    ROW_EMPHASISED = 'RowEmphasised',
    ROW_ACTION = 'RowAction',
    TIMER_BUTTON = 'TimerButton',
    BUTTON_ROW_TIMER = 'ButtonRowTimer',
    BUTTON_BANNER = 'ButtonBanner',
    BUTTON_MESSAGE = 'ButtonMessage',
    BUTTON_CIRCLE_ANIMATED = 'ButtonCircleAnimated',
    BUTTON_GOOGLE_PAY = 'GooglePayButton',
    BUTTON_APPLE_PAY = 'ApplePayButtonWidget',
    BUTTON_SIGN_IN_WITH_APPLE = 'SignInWithApple',
    BUTTON_SIGN_IN_WITH_GOOGLE = 'SignInWithGoogle',
    DETAILS_SEPARATE_TEXT = 'DetailsSeparateText',
    BUTTON_MENU = 'ButtonMenu',
    INFO_BANNER = 'InfoBanner',
}

export enum StoriesEnum {
    STORIES = 'PromoStories',
    BRAZE_BANNER = 'BrazeBannerWidget',
}

export enum TextEnum {
    TEXT = 'Text',
    TEXT_LINKED = 'LinkedText',
    BALANCE = 'Balance',
    APP_VERSION = 'AppVersionText',
}

export enum CheckboxEnum {
    SWITCHER = 'Switcher',
    CHECKBOX = 'Checkbox',
}

export enum InputEnum {
    STROKED = 'Stroked',
    PHONE_TEXT_INPUT = 'PhoneTextInput',
    DATE_MASK_TEXT_INPUT = 'DateMaskedTextInput',
    AUTO_SUBMIT_TEXT_INPUT = 'AutoSubmitTextInput',
    SEARCH_ADDRESS_INPUT = 'SearchAddressInput',
    OTP_INPUT = 'OTPInput',
}

export enum ActionWidgetEnum {
    ACTION_WIDGET = 'ActionWidget',
}

export enum DropdownEnum {
    DROPDOWN = 'Dropdown',
}

export enum ListEnum {
    SELECT = 'Select',
    TRANSACTIONS = 'TransactionsList',
    CURRENCY = 'CurrencyList',
    TEMPLATE = 'TemplateList',
    PROFILE_MENU = 'ProfileMenu',
    CONTACTS = 'ContactsList',
    STATUS_TRACKER = 'StatusTracker',
}

export enum RowEnum {
    ROW_REGULAR = 'RowRegular',
    SELECTOR_REGULAR = 'SelectorRegular',
    SELECTOR_EXTRA = 'SelectorExtra',
}

export enum CalculatorEnum {
    CALCULATOR = 'Calculator',
    TOP_UP = 'TopUp',
}

export enum CarouselEnum {
    CAROUSEL = 'Carousel',
}

export enum SeparatorEnum {
    SEPARATOR = 'Separator',
}

export enum ImageEnum {
    VISUAL = 'Visual',
    PROFILE_IMAGE = 'ProfileImage',
    QR_CODE = 'QRCode',
}

export enum CardEnum {
    CARD_INPUT = 'CardInput',
    CARD_BALANCE = 'CardBalance',
    CARD_VIEW = 'CardView',
}

export enum MpiEnum {
    MPI = 'Mpi',
}

export enum KycEnum {
    SUMSUB = 'Sumsub',
    KYC_PROVIDER = 'KycProvider',
    ZENDESK_CHAT_WIDGET = 'ZendeskChatWidget',
}

export enum ECardBalancePaymentSystem {
    MASTERCARD = 'mastercard',
    VISA = 'visa',
}

export enum ECardBalanceStatus {
    ACTIVE = 'active',
    NOT_ISSUED = 'notIssued',
    KYC_IN_PROGRESS = 'kycInProgress',
    SUSPICIOUS_ACTIVITY = 'suspiciousActivity',
    FROZEN = 'frozen',
    EXPIRED = 'expired',
}

export enum ECardView {
    ACTIVE = 'active',
    DISABLED = 'disabled',
    ACCOUNT_NUMBER_ACTIVE = 'accountNumberActive',
    ACCOUNT_NUMBER_DISABLED = 'accountNumberDisabled',
}

export enum TransactionStatusEnum {
    AWAITING = 'AWAITING',
    CREATED = 'CREATED',
    INPUT = 'INPUT',
    INPUT_FINISHED = 'INPUT FINISHED',
    OUTPUT = 'OUTPUT',
    OUTPUT_FINISHED = 'OUTPUT FINISHED',
    REFUND = 'REFUND',
    REFUND_FINISHED = 'REFUND FINISHED',
    SUCCESS = 'SUCCESS',
    FAIL = 'FAIL',
    HALT = 'HALT',
    NONE = 'NONE',
    SUCCESSFUL_TOPUP = 'SUCCESSFUL_TOPUP',
}
export enum GooglePayTokenizationType {
    DIRECT = 'DIRECT',
    PAYMENT_GATEWAY = 'PAYMENT_GATEWAY',
}
export enum StatusTrackerEnum {
    INITIAL = 'initial',
    IN_PROGRESS = 'inProgress',
    WAITING = 'waiting',
    SUCCESS = 'success',
    WARNING = 'warning',
    FAILED = 'failed',
}

export enum ConsumerActionPlayerNameEnums {
    copy = 'copy',
    closeBottomsheet = 'closeBottomsheet',
    share = 'share',
    execute = 'execute',
    changeLanguage = 'changeLanguage',
    showHelperDescription = 'showHelperDescription',
    showErrorHelperDescription = 'showErrorHelperDescription',
    redirect = 'redirect',
    lock_source = 'lock_source',
}
export enum ConsumerActionTypeEnums {
    onSuccess = 'onSuccess',
    onFailure = 'onFailure',
    onError = 'onError',
}

export enum EConsumerLocalStorageItems {
    PREFERRED_BALANCE = 'consumer3_balance_widget_preferred_balance',
}

export enum TranslationKeys {
    ButtonRetry = 'mobile.button.retry',
    GeneralErrorText = 'mobile.error.general',
}
